<template>
  <div id="navigation">
    <div class="wap_index-nav">
      <div class="wap_index-nav-box">
        <div class="wap_index-nav-box-1" ref="control">
          <div class="flex" ref="moveNav">
            <div
              class="nav-a"
              @click="navChoice(index, item)"
              v-for="(item, index) in wapNavList"
              :key="index"
            >
              <div
                class="nav_bgSize"
                :class="
                  item.show ? `pop_navIco${index}1` : `pop_navIco${index}`
                "
              ></div>
              <div v-if="item.special" :class="item.class">
                <div v-if="item.title">{{ item.title }}</div>
              </div>
              <div v-else :class="item.show ? 'sizeColor' : ''">
                {{ item.title }}
              </div>
            </div>
          </div>
        </div>
        <div @click.stop="popShow = true"></div>
      </div>
    </div>
    <!-- 导航栏弹窗 -->
    <transition
      enter-active-class="nav_pop_enter"
      leave-active-class="nav_pop_leave"
    >
      <div v-if="popShow" class="nav_pop">
        <div class="nav_pop-box">
          <div class="close">
            <img
              @click="popShow = false"
              src="../../assets/images/web/close.png"
              alt="千年游戏盒子"
            />
          </div>
          <div class="pop_list" :class="popShow ? 'pop_listPlay' : ''">
            <div
              class="pop_list_li"
              @click="navChoice(index, item)"
              v-for="(item, index) in wapNavList"
              :key="index"
              :class="index == wapNavList.length - 1 ? 'borderNo' : ''"
            >
              <div>
                <div
                  :class="item.show ? `navIco${index}1` : `navIco${index}`"
                ></div>
              </div>
              <div v-if="!item.special">
                <div
                  class=""
                  v-if="index < 9"
                  :class="item.show ? 'sizeChoice' : ''"
                >
                  0{{ index + 1 }}
                </div>
                <div v-else :class="item.show ? 'sizeChoice' : ''">
                  {{ index + 1 }}
                </div>
              </div>
              <div v-if="!item.special" :class="item.show ? 'sizeChoice' : ''">
                {{ item.title }}
              </div>
              <div v-else :class="item.class">
                <div v-if="item.title">{{ item.title }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  props: {
    activeIndex: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      isShow: false,
      popShow: false,
      lastShow: false,
      scrollShow: false,
      slideSwiper: null, //swiper 实例
      sred: 0,
      wapNavList: [
        {
          title: "首页",
          show: true,
          href: "#bannerView",
        },
        {
          title: "合作流程",
          show: false,
          href: "#hzFlow",
        },
        {
          title: "引擎介绍",
          show: false,
          href: "#yqJs",
        },
        {
          title: "商务合作",
          show: false,
          href: "#business",
        },
        {
          title: "授权展示",
          show: false,
          href: "#sqshow",
        },
        {
          title: "游戏专区",
          show: false,
          href: "#gameSingle",
        },
        {
          title: "下载中心",
          show: false,
          href: "#download",
        },
        {
          show: false,
          url: "https://www.qn000.com",
          special: true,
          class: "enterinto_gif",
        },
        {
          show: false,
          class: "enterinto_img",
          special: true,
          url: "https://www.qn2024.com",
        },
      ],
    };
  },
  created() {},
  mounted() {},
  watch: {
    activeIndex: {
      // val 是对应的轮播的slide  sred 对应的是导航条
      handler(val) {
        if (val.id || val.id == 0) {
          this.wapNavList.forEach((item) => {
            item.show = false;
          });
          this.wapNavList[val.id].show = true;
          this.navHar(val.id);
        }
        this.sred = val;
      },
      deep: true,
    },
  },
  methods: {
    goToWebsite() {
      window.location.href = "https://www.qn000.com/#/";
    },
    ispopShow() {
      this.popShow = !this.popShow;
      this.isShow = !this.isShow;
    },
    navHar(index) {
      let controlWidth = this.$refs.control.offsetWidth;
      let displacement = 0;
      if (index != 9) {
        displacement =
          this.$refs.moveNav.children[index].offsetLeft -
          controlWidth / 2 +
          this.$refs.moveNav.children[index].offsetWidth / 2;
      }
      if (index >= 2) {
        this.$refs.control.scrollLeft = displacement;
      } else {
        this.$refs.control.scrollLeft = 0;
      }
    },
    // 导航弹窗 选中
    navChoice(index, item) {
      if (item.special) {
        this.goToWebsite();
        return;
      }
      let controlWidth = this.$refs.control.offsetWidth;
      let displacement =
        this.$refs.moveNav.children[index].offsetLeft -
        controlWidth / 2 +
        this.$refs.moveNav.children[index].offsetWidth / 2;
      if (index >= 2) {
        this.$refs.control.scrollLeft = displacement;
      } else {
        this.$refs.control.scrollLeft = 0;
      }
      this.wapNavList.forEach((item) => {
        item.show = false;
      });
      this.wapNavList[index].show = true;
      this.$emit("navChang", index);
      this.popShow = false;
      this.isShow = false;
    },
  },
};
</script>

<style>
@import "../../assets/css/swiper-bundle.min.css";
</style>

<style lang="scss" scoped>
#navigation {
  width: 100%;
  // height: 1.21rem;
  position: sticky;
  top: 0;
  z-index: 1000;
  background: #000;
  flex-shrink: 0;

  .wap_index-nav {
    position: fixed;
    top: 0.4rem /* 15/37.5 */;
    left: 50%;
    right: 0;
    transform: translateX(-50%);
    /* margin: 0 auto; */
    width: 9.333333rem /* 350/37.5 */;
    width: 90%;
    z-index: 1;
  }

  .wap_index-nav-box {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: space-between;
    /* align-items: center; */
  }

  .nav_pop {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    background: #393738;
    z-index: 9999999999999999;
    overflow: hidden;
  }

  .nav_pop .nav_pop-box {
    width: 16.5rem /* 330/20 */;
    margin: 0 auto;
    width: 88%;
  }

  .nav_pop .nav_pop-box .close {
    padding-top: 0.533333rem /* 20/37.5 */;
    padding-bottom: 0.533333rem /* 20/37.5 */;
    display: flex;
    flex-direction: row-reverse;
  }

  .nav_pop .nav_pop-box .close img {
    display: block;
    width: 0.56rem /* 21/37.5 */;
    height: 0.533333rem /* 20/37.5 */;
  }

  .wap_index .wap_index-nav > div:nth-child(1) {
    width: 15rem;
    height: 100%;
    background: aqua;
    /* overflow: hidden; */
    overflow-x: auto;
    display: flex;
  }

  .wap_index .wap_index-nav > div:nth-child(1) a {
    width: 25%;
    font-size: 0.373333rem /* 14/37.5 */;
    color: #fff;
    display: flex;
    align-items: center;
  }
  .nav_bgSize {
    margin-right: 0.213333rem /* 8/37.5 */;
  }
  .pop_navIco0 {
    width: 0.373333rem /* 14/37.5 */;
    height: 0.426667rem /* 16/37.5 */;
    background: url("../../assets/images/web/home1.png") no-repeat;
    background-size: cover;
  }

  .pop_navIco01 {
    width: 0.373333rem /* 14/37.5 */;
    height: 0.426667rem /* 16/37.5 */;
    background: url("../../assets/images/web/home.png") no-repeat;
    background-size: cover;
  }

  .pop_navIco1 {
    width: 0.533333rem /* 20/37.5 */;
    height: 0.533333rem /* 20/37.5 */;
    background: url("../../assets/images/web/handshake1.png") no-repeat center;
    background-size: cover;
  }

  .pop_navIco11 {
    width: 0.533333rem /* 20/37.5 */;
    height: 0.533333rem /* 20/37.5 */;
    background: url("../../assets/images/web/handshake.png") no-repeat center;
    background-size: cover;
  }

  .pop_navIco2 {
    width: 0.613333rem /* 23/37.5 */;
    height: 0.426667rem /* 16/37.5 */;
    background: url("../../assets/images/web/share1.png") no-repeat center;
    background-size: cover;
  }

  .pop_navIco21 {
    width: 0.613333rem /* 23/37.5 */;
    height: 0.426667rem /* 16/37.5 */;
    background: url("../../assets/images/web/share.png") no-repeat center;
    background-size: cover;
  }

  .pop_navIco3 {
    width: 0.4rem /* 15/37.5 */;
    height: 0.453333rem /* 17/37.5 */;
    background: url("../../assets/images/web/collect1.png") no-repeat center;
    background-size: cover;
  }

  .pop_navIco31 {
    width: 0.4rem /* 15/37.5 */;
    height: 0.453333rem /* 17/37.5 */;
    background: url("../../assets/images/web/collect.png") no-repeat center;
    background-size: cover;
  }
  .pop_navIco4 {
    width: 0.426667rem /* 16/37.5 */;
    height: 0.426667rem /* 16/37.5 */;
    background: url("../../assets/images/web/person1.png") no-repeat center;
    background-size: cover;
  }

  .pop_navIco41 {
    width: 0.426667rem /* 16/37.5 */;
    height: 0.426667rem /* 16/37.5 */;
    background: url("../../assets/images/web/person2.png") no-repeat center;
    background-size: cover;
  }
  .pop_navIco5 {
    width: 0.56rem /* 21/37.5 */;
    height: 0.426667rem /* 16/37.5 */;
    background: url("../../assets/images/web/game_icon1.png") no-repeat center;
    background-size: cover;
  }

  .pop_navIco51 {
    width: 0.56rem /* 21/37.5 */;
    height: 0.426667rem /* 16/37.5 */;
    background: url("../../assets/images/web/game_icon2.png") no-repeat center;
    background-size: cover;
  }
  .pop_navIco6 {
    width: 0.426667rem /* 16/37.5 */;
    height: 0.426667rem /* 16/37.5 */;
    background: url("../../assets/images/web/download1.png") no-repeat center;
    background-size: cover;
  }

  .pop_navIco61 {
    width: 0.426667rem /* 16/37.5 */;
    height: 0.426667rem /* 16/37.5 */;
    background: url("../../assets/images/web/download.png") no-repeat center;
    background-size: cover;
  }
  .pop_navIco7 {
    width: 0.426667rem /* 16/37.5 */;
    height: 0.426667rem /* 16/37.5 */;
    background: url("../../assets/images/web/enterinto1.png") no-repeat center;
    background-size: cover;
  }
  .pop_navIco8 {
    width: 0.426667rem /* 16/37.5 */;
    height: 0.426667rem /* 16/37.5 */;
    background: url("../../assets/images/web/enterinto1.png") no-repeat center;
    background-size: cover;
  }

  .pop_navIco71 {
    width: 0.426667rem /* 16/37.5 */;
    height: 0.426667rem /* 16/37.5 */;
    background: url("../../assets/images/web/enterinto.png") no-repeat center;
    background-size: cover;
  }
  .wap_index-nav-box-1 {
    flex: 0.92;
    display: flex;
    overflow-x: scroll;
  }

  .wap_index-nav-box-1::-webkit-scrollbar {
    background-color: transparent;
  }

  .wap_index-nav-box-1 > div > div {
    flex-shrink: 0;
  }

  .nav-a {
    display: flex;
    align-items: center;
    color: #fff;
    font-size: 0.426667rem /* 16/37.5 */;
    margin-right: 1.226667rem /* 46/37.5 */;
  }

  .nav-a .sizeColor {
    color: #ff0e0e;
  }

  .wap_index-nav-box > div:nth-child(2) {
    width: 0.506667rem /* 19/37.5 */;
    height: 0.506667rem /* 19/37.5 */;
    background: url("../../assets/images/web/nav.png") no-repeat center;
    background-size: cover;
    position: relative;
  }
  .pop_list {
    height: 0;
    overflow: hidden;
    animation: poplistmy 0.4s linear both;
  }

  @keyframes poplistmy {
    from {
      height: 0px;
    }
    to {
      height: 25rem; /* 500/20 */
    }
  }
  .pop_list_li {
    display: flex;
    color: #fff;
    font-size: 0.426667rem /* 16/37.5 */;
    padding-top: 0.613333rem /* 23/37.5 */;
    padding-bottom: 0.613333rem /* 23/37.5 */;
    border-bottom: 1px solid #6c6b6b;
    align-items: center;
  }

  .pop_list_li > div:nth-child(1) {
    width: 0.533333rem /* 20/37.5 */;
    margin-right: 0.666667rem /* 25/37.5 */;
    display: flex;
    justify-content: center;
  }
  .pop_list_li > div:nth-child(2) {
    margin-right: 0.266667rem /* 10/37.5 */;
  }

  .navIco0 {
    width: 0.533333rem /* 20/37.5 */;
    height: 0.533333rem /* 20/37.5 */;
    background: url("../../assets/images/web/home1.png") no-repeat center;
    background-size: cover;
  }

  .navIco01 {
    width: 0.533333rem /* 20/37.5 */;
    height: 0.533333rem /* 20/37.5 */;
    background: url("../../assets/images/web/home.png") no-repeat center;
    background-size: cover;
  }

  .navIco1 {
    width: 0.613333rem /* 23/37.5 */;
    height: 0.426667rem /* 16/37.5 */;
    background: url("../../assets/images/web/handshake1.png") no-repeat center;
    background-size: cover;
  }

  .navIco11 {
    width: 0.613333rem /* 23/37.5 */;
    height: 0.426667rem /* 16/37.5 */;
    background: url("../../assets/images/web/handshake.png") no-repeat center;
    background-size: cover;
  }

  .navIco2 {
    width: 0.533333rem /* 20/37.5 */;
    height: 0.533333rem /* 20/37.5 */;
    background: url("../../assets/images/web/share1.png") no-repeat center;
    background-size: cover;
  }

  .navIco21 {
    width: 0.533333rem /* 20/37.5 */;
    height: 0.533333rem /* 20/37.5 */;
    background: url("../../assets/images/web/share.png") no-repeat center;
    background-size: cover;
  }

  .navIco3 {
    width: 0.4rem /* 15/37.5 */;
    height: 0.453333rem /* 17/37.5 */;
    background: url("../../assets/images/web/collect1.png") no-repeat center;
    background-size: cover;
  }

  .navIco31 {
    width: 0.4rem /* 15/37.5 */;
    height: 0.453333rem /* 17/37.5 */;
    background: url("../../assets/images/web/collect.png") no-repeat center;
    background-size: cover;
  }

  .navIco4 {
    width: 0.426667rem /* 16/37.5 */;
    height: 0.506667rem /* 19/37.5 */;
    background: url("../../assets/images/web/person1.png") no-repeat center;
    background-size: cover;
  }

  .navIco41 {
    width: 0.426667rem /* 16/37.5 */;
    height: 0.506667rem /* 19/37.5 */;
    background: url("../../assets/images/web/person2.png") no-repeat center;
    background-size: cover;
  }
  .navIco5 {
    width: 0.56rem /* 21/37.5 */;
    height: 0.426667rem /* 16/37.5 */;
    background: url("../../assets/images/web/game_icon1.png") no-repeat center;
    background-size: cover;
  }

  .navIco51 {
    width: 0.56rem /* 21/37.5 */;
    height: 0.426667rem /* 16/37.5 */;
    background: url("../../assets/images/web/game_icon2.png") no-repeat center;
    background-size: cover;
  }
  .navIco6 {
    width: 0.426667rem /* 16/37.5 */;
    height: 0.506667rem /* 19/37.5 */;
    background: url("../../assets/images/web/download1.png") no-repeat center;
    background-size: cover;
  }

  .navIco61 {
    width: 0.426667rem /* 16/37.5 */;
    height: 0.506667rem /* 19/37.5 */;
    background: url("../../assets/images/web/download.png") no-repeat center;
    background-size: cover;
  }
  .navIco7 {
    width: 0.426667rem /* 16/37.5 */;
    height: 0.506667rem /* 19/37.5 */;
    background: url("../../assets/images/web/enterinto1.png") no-repeat center;
    background-size: cover;
  }
  .navIco8 {
    width: 0.426667rem /* 16/37.5 */;
    height: 0.506667rem /* 19/37.5 */;
    background: url("../../assets/images/web/enterinto1.png") no-repeat center;
    background-size: cover;
  }

  .navIco71 {
    width: 0.426667rem /* 16/37.5 */;
    height: 0.506667rem /* 19/37.5 */;
    background: url("../../assets/images/web/enterinto.png") no-repeat center;
    background-size: cover;
  }
  .enterinto_gif {
    width: 4.266667rem /* 160/37.5 */;
    height: 0.426667rem /* 16/37.5 */;
    background: url("../../assets/images/web/enterinto_gif.gif") no-repeat;
    background-size: contain;
  }
  .enterinto_img {
    width: 4.266667rem /* 160/37.5 */;
    height: 0.426667rem /* 16/37.5 */;
    background: url("../../assets/images/web/enterinto_gif.png") no-repeat;
    background-size: contain;
  }
  .sizeChoice {
    color: #f1412a;
  }

  .sign {
    width: 2.56rem /* 96/37.5 */;
    height: 2.56rem /* 96/37.5 */;
    position: fixed;
    left: 0;
    bottom: 0;
    right: 0;
    margin: 0 auto;
    z-index: 1;
    // background: url("../../assets/images/web/sign.png") no-repeat center;
    background-size: cover;
    animation: myfirst 2s ease-in-out both infinite;
  }
  @keyframes myfirst {
    0% {
      transform: translateY(-0.4rem /* 15/37.5 */);
      opacity: 0;
    }
    50% {
      transform: translateY(0.266667rem /* 10/37.5 */);
      opacity: 1;
    }
    100% {
      transform: translateY(-0.4rem /* 15/37.5 */);
      opacity: 0;
    }
  }
}
@media (max-width: 750px) and (max-height: 600px) {
  #navigation {
    .nav_pop {
      .nav_pop-box {
        .close {
          padding-top: 0.32rem /* 12/37.5 */;
          padding-bottom: 0.533333rem /* 20/37.5 */;
        }
      }
    }
    .pop_list_li {
      padding-top: 0.346667rem /* 13/37.5 */;
      padding-bottom: 0.346667rem /* 13/37.5 */;
    }
  }
}
</style>
